import { VirtualCardType } from 'modules/virtual-cards/constants'

/** Requested action from the bulk upload template (CSV column `action`). */
export enum VcnManagementAction {
  TERMINATE = 'terminate',
  TERMINATE_AND_NEW = 'terminate_and_new',
  CREATE_NEW = 'create_new',
}

export interface VcnBulkUploadPreviewItem {
  benefitId: string
  action: VcnManagementAction
  /** Provider for created cards (CSV column `provider`); backend defaults to WEX when omitted. */
  provider?: VirtualCardType
}

export interface VcnBulkUploadPreviewRequest {
  items: VcnBulkUploadPreviewItem[]
}

/** One row returned from the preview API (matched or not). */
export interface VcnBulkUploadPreviewResultRow {
  benefitId: string
  requestedAction: VcnManagementAction
  found: boolean
  vcnToken?: string
  lastFour?: string
  vcnProvider?: string
  /** Provider the new card will use (create actions); WEX when the upload omitted it. */
  requestedProvider?: VirtualCardType
}

export interface VcnBulkUploadPreviewResponse {
  rows: VcnBulkUploadPreviewResultRow[]
  /** Rows that matched a VCN in the system. */
  matchedCount: number
}
